import { isPlatformBrowser } from '@angular/common';
import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';

import { IGoogleAnalyticsSettings } from '../interfaces/IGoogleAnalyticsSettings';

export const GOOGLE_ANALYTICS_SETTINGS_TOKEN = new InjectionToken<IGoogleAnalyticsSettings>("GOOGLE_ANALYTICS_SETTINGS", {
    factory: () => ({ trackingCode: "", enableTracing: false })
});

export const WINDOW_TOKEN = new InjectionToken<Window>("WINDOW", {
    providedIn: "root",
    factory: () => isPlatformBrowser(inject(PLATFORM_ID)) ? window : null
})

export const GOOGLE_ANALYTICS_DATA_LAYER_TOKEN = new InjectionToken("WINDOW_DATA_LAYER", {
    providedIn: "root",
    factory: () => {
        let window = inject(WINDOW_TOKEN);
        return (window && window["dataLayer"])
            ? window["dataLayer"]
            : (window)
                ? window["dataLayer"] = []
                : null
        //return (window) ? window["dataLayer"] = window["dataLayer"] || [] : null;
    }
})

export const GOOGLE_ANALYTICS_GTAG_TOKEN = new InjectionToken("GOOGLE_ANALYTICS_GTAG", {
    providedIn: "root",
    factory: () => {
        let window = inject<Window>(WINDOW_TOKEN);
        let dataLayer = inject<any[]>(GOOGLE_ANALYTICS_DATA_LAYER_TOKEN);
        return (window && window["gtag"]) 
                ? window["gtag"]
                : (dataLayer) 
                    ? window["gtag"]=function(){  dataLayer.push(arguments);} 
                    : function(){}
    }
})
